import confetti from "canvas-confetti";

const FOCUSABLE_SELECTOR = [
  "a[href]",
  "button:not([disabled])",
  "textarea:not([disabled])",
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "[tabindex]:not([tabindex='-1'])"
].join(", ");

export default function registerCelebration(Alpine) {
  Alpine.data("celebration", ({ variant }) => ({
    isOpen: false,
    previouslyFocused: null,

    open() {
      this.previouslyFocused = document.activeElement;
      this.isOpen = true;
      this.$nextTick(() => {
        this.$root.dispatchEvent(
          new CustomEvent("celebration:open", {
            bubbles: true,
            detail: { variant }
          })
        );
        this.focusFirst();
        if (variant === "won") {
          const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
          if (!prefersReducedMotion) {
            confetti({ particleCount: 80, spread: 70, origin: { x: 0.3, y: 0.5 }, disableForReducedMotion: true });
            confetti({ particleCount: 80, spread: 70, origin: { x: 0.7, y: 0.5 }, disableForReducedMotion: true });
          }
        }
      });
    },

    close() {
      this.isOpen = false;
      if (this.previouslyFocused && typeof this.previouslyFocused.focus === "function") {
        this.previouslyFocused.focus();
      }
    },

    focusFirst() {
      const focusables = this.focusableElements();
      if (focusables.length > 0) focusables[0].focus();
    },

    focusableElements() {
      return Array.from(this.$root.querySelectorAll(FOCUSABLE_SELECTOR));
    },

    trapFocus(event) {
      if (event.key !== "Tab") return;
      const focusables = this.focusableElements();
      if (focusables.length === 0) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    },

    handleBackdropClick(event) {
      if (event.target === this.$root) this.close();
    }
  }));
}
